export enum NgxMatTimepickerFormat {
    TWELVE = "hh:mm a",
    TWELVE_SHORT = "h:m a",
    TWENTY_FOUR = "HH:mm",
    TWENTY_FOUR_SHORT = "H:m"
}
